import axios, { AxiosRequestConfig } from 'axios';
// type
import { User } from '../types/user';
import { ChallengeResponse } from '../types/challengeResponse';
import { ChangePasswordRequest } from '../types/changePasswordRequest';
import { ChallengeRequest } from '../types/challengeRequest';
// service
import { axiosInstance } from '../common/axios-interceptor';

// 環境変数
const MOCK_MODE: boolean = process.env.REACT_APP_MOCK_MODE === "true";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// **ダミーデータ**
const mockUsers: User[] = [
    { userId: "1", name: "正樹", address: "yamada@example.com", role: "ADMIN" },
    { userId: "2", name: "久恵", address: "sato@example.com", role: "NORMAL" },
    { userId: "3", name: "ねね", address: "suzuki@example.com", role: "NORMAL" },
    { userId: "4", name: "いっさ", address: "suzuki@example.com", role: "NORMAL" },
];

const mockChallenge: ChallengeResponse = {
    accessToken: "aaaaaaaaaaa",
    idToken: "bbbbbb",
    user: {
        userId: "",
        name: "",
        address: "",
        role: 'NORMAL'
    },
    users: [
    ]
}

let users = [...mockUsers];

/**
 * チャレンジ
 * @param param 
 * @returns 
 */
export const challenge = async (param: ChallengeRequest) => {
    if (MOCK_MODE) {
        // 初期化
        mockChallenge.users = [];
        mockUsers.map((user: User) => {
            mockChallenge.users.push({ userId: user.userId, name: user.name, address: user.address ,role: user.role });
        });
        mockChallenge.user = mockUsers[0];
        return new Promise<ChallengeResponse>((resolve) => {
            setTimeout(() => resolve(mockChallenge), 500);
        });
    } else {
        try {
            const config = { skipAuth: true } as AxiosRequestConfig & { skipAuth?: boolean }
            const response = await axiosInstance.post(`${BASE_URL}/user/challenge`, param, config);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * ユーザデータ取得
 * @returns 
 */
export const fetchUsers = async () => {
    if (MOCK_MODE) {
        return new Promise<User[]>((resolve) => {
            setTimeout(() => resolve(users), 500);
        });
    } else {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/user`);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * ユーザ新規作成
 * @param user 
 * @returns 
 */
export const createUser = async (user: Omit<User, 'id'>) => {
    if (MOCK_MODE) {
        return new Promise<User>((resolve) => {
            setTimeout(() => {
                const newOperator = { ...user, id: String(users.length + 1) };
                users.push(newOperator);
                resolve(newOperator);
            }, 500);
        });
    } else {
        try {
            const response = await axiosInstance.post(`${BASE_URL}/user`, user);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * ユーザ更新
 * @param user 
 * @returns 
 */
export const updateUser = async (user: User) => {
    if (MOCK_MODE) {
        return new Promise<User>((resolve) => {
            setTimeout(() => {
                users = users.map(u => u.userId === user.userId ? user : u);
                resolve(user);
            }, 500);
        });
    } else {
        try {
            const response = await axiosInstance.patch(`${BASE_URL}/user`, user);
            return response.data;
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * ユーザ削除
 * @param userId 
 * @returns 
 */
export const deleteUser = async (userId: string) => {
    if (MOCK_MODE) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                users = users.filter(u => u.userId !== userId);
                resolve();
            }, 500);
        });
    } else {
        try {
            await axiosInstance.delete(`${BASE_URL}/user/${userId}`);
            return {};
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * パスワード初期化
 * @param userId 
 * @returns 
 */
export const initPassword = async (userId: any) => {
    if (MOCK_MODE) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });
    } else {
        try {
            await axiosInstance.post(`${BASE_URL}/user/password/init`, userId);
            return {};
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};

/**
 * パスワード変更
 * @param param 
 * @returns 
 */
export const changePasswordApi = async (param: ChangePasswordRequest) => {
    if (MOCK_MODE) {
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });
    } else {
        try {
            await axiosInstance.post(`${BASE_URL}/user/password/change`, param);
            return {};
        } catch (e) {
            console.log(e);
            return null;
        }
    }
};